// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1PNIP","label":"Category_label___McL5","content":"Category_content__2gdn8","header":"Category_header__1DTd0","location":"Category_location__3x5p0"};